export default [
    {
      path: '/cashback',
      name: 'cashback',
      component: () => import('@/views/cashback/AppCashback'),
    },
  ];
  